import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateTagMutation } from "../graphql/mutations";
import type {
  UpdateTagMutationType,
  UpdateTagMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateTagMutation = (
  options?: MutationHookOptions<
    UpdateTagMutationType,
    UpdateTagMutationVariablesType
  >
) => {
  return useMutation<UpdateTagMutationType, UpdateTagMutationVariablesType>(
    UpdateTagMutation,
    options
  );
};
